var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHouseAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.147,
    height: 30.756,
    viewBox: "0 0 35.147 30.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.784,19.138l2.61-2.087V32.558a2.2,2.2,0,0,0,2.2,2.2h6.59a2.2,2.2,0,0,0,2.2-2.2V23.771h4.394v8.787a2.2,2.2,0,0,0,2.2,2.2h6.59a2.2,2.2,0,0,0,2.2-2.2V17.051l2.61,2.087a1.1,1.1,0,0,0,1.373-1.718L18.262,4.24a1.1,1.1,0,0,0-1.373,0l-5.9,4.723V6.2a2.2,2.2,0,0,0-4.394,0v6.281L.413,17.42a1.1,1.1,0,0,0,1.371,1.718ZM17.574,6.5l10.984,8.787V32.558h-6.59V21.574H13.181V32.558H6.59V15.294Z",
    transform: "translate(-0.002 -3.999)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHouseAlt);
export default __webpack_public_path__ + "static/media/icon_house_alt.00a0eeee.svg";
export { ForwardRef as ReactComponent };